module.exports = __webpack_public_path__ + "static/media/28_tn.16318924.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/28_tn.jpg
// module id = 458
// module chunks = 0